import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

interface TemplateItem {
  id: string;
  name: string;
}

interface SurveyTemplateLinksProps {
  templates?: TemplateItem[];
  selectedTemplateIds: string[];
  search: string;
  onSearchChange: (value: string) => void;
  onToggle: (id: string, checked: boolean) => void;
}

export const SurveyTemplateLinks = ({
  templates,
  selectedTemplateIds,
  search,
  onSearchChange,
  onToggle,
}: SurveyTemplateLinksProps) => {
  return (
    <div className="space-y-2">
      <Label>Survey Templates</Label>
      <Input
        placeholder="Search templates..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      <div className="grid grid-cols-2 gap-2 max-h-40 overflow-y-auto border rounded-md p-3">
        {(templates || [])
          .filter((t) => t.name.toLowerCase().includes(search.toLowerCase()))
          .map((t) => {
            const checked = selectedTemplateIds.includes(t.id);
            return (
              <div key={t.id} className="flex items-center space-x-2">
                <Checkbox
                  id={`tmpl-${t.id}`}
                  checked={checked}
                  onCheckedChange={(c) => onToggle(t.id, Boolean(c))}
                />
                <Label htmlFor={`tmpl-${t.id}`} className="text-sm">
                  {t.name}
                </Label>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default SurveyTemplateLinks;

